import * as THREE from 'three';

/**
 * Convert geographic coordinates (latitude/longitude in degrees) to a
 * Three.js Vector3 position on the globe surface.
 *
 * Three.js default SphereGeometry UV mapping places the prime meridian
 * (lon 0°, texture center u=0.5) on the **+X axis**.  East longitude
 * proceeds clockwise (toward -Z) when viewed from above.
 *
 * Derivation from SphereGeometry vertex formula:
 *   phi = lon_rad + PI  →  x = -cos(phi)*sin(theta) = cos(lon)*sin(theta)
 *                           z =  sin(phi)*sin(theta) = -sin(lon)*sin(theta)
 *   theta encodes latitude  →  sin(theta) = cos(lat), cos(theta) = sin(lat)
 *
 * @param latDeg  Latitude in degrees (-90 to 90)
 * @param lonDeg  Longitude in degrees (-180 to 180)
 * @param radius  Globe radius plus offset (default 1.01 for slight surface elevation)
 */
export function latLonToPosition(
  latDeg: number,
  lonDeg: number,
  radius: number = 1.01
): THREE.Vector3 {
  const lat = latDeg * (Math.PI / 180);
  const lon = lonDeg * (Math.PI / 180);
  return new THREE.Vector3(
     radius * Math.cos(lat) * Math.cos(lon),    // +X = prime meridian
     radius * Math.sin(lat),                     // +Y = north pole
    -radius * Math.cos(lat) * Math.sin(lon)      // -Z = east
  );
}
